import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { loginRequest } from '@/auth/msalConfig';

/**
 * /login — sign in with Microsoft.
 *
 * Reads ?redirect= so we can bounce the user back to the original protected
 * URL they were trying to reach. MSAL handles the popup/redirect dance; the
 * post-redirect side trip lands at /auth/callback where the redirect-promise
 * is consumed (in main.tsx) before this component is even reached.
 */
export function Login() {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirectTo = params.get('redirect') ?? '/tickets';

  useEffect(() => {
    if (accounts.length > 0) {
      void navigate(redirectTo, { replace: true });
    }
  }, [accounts.length, navigate, redirectTo]);

  return (
    <div className="min-h-screen grid place-items-center bg-background px-4">
      <div className="w-full max-w-sm rounded-xl border bg-card text-card-foreground p-8 shadow-lg">
        <div className="flex flex-col items-center text-center mb-6">
          <img src="/aes-logo.svg" alt="AES" className="h-12 w-auto" />
          <div className="mt-2 text-sm font-semibold">I.T. Helpdesk</div>
          <div className="text-xs text-muted-foreground">Sign in with your AES account</div>
        </div>

        <button
          type="button"
          onClick={() => instance.loginRedirect(loginRequest)}
          className="w-full rounded-md bg-primary text-primary-foreground py-2.5 font-medium hover:opacity-90 transition"
        >
          Sign in with Microsoft
        </button>

        <p className="mt-6 text-xs text-muted-foreground text-center">
          Single sign-on. Use your <span className="font-medium">@aesintl.com</span> account.
        </p>
      </div>
    </div>
  );
}
